import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
  useNavigate,
} from 'react-router-dom';

// widgets
import ImageComp from '../widget/w-image';
import FooterMain from './footer_main';

interface HeaderProps {}
const Header: React.FC<HeaderProps> = () => {

 
  return (
    <div className='header-section'>
      <div className='page-container'>
        <div className='mt-2 bg-d-s w-100 p-3'>
          <ImageComp
            imageClass='logo ms-3'
            src='/asset/logo_icon.svg'
            alt='Arivonix_Logo'
            ariaLabel='Arivonix Logo'
            width={150}
          ></ImageComp>
        </div>
        <div className='w-100 position-relative d-flex'>
          <div className={'w-100 main-page-height overflow-hidden'}>
            <Outlet />
          </div>
        </div>
      </div>
      <div className='text-center'>
        <FooterMain />
      </div>
    </div>
  );
};

export default Header;
